export const ICS205A_TABLE_MIN_WIDTH_PX = 900;

export const ICS205A_COLUMN_LABELS = {
  index: '#',
  assignment: 'Assignment',
  name: 'Name',
  cellPhone: 'Cell Phone #',
  radioFrequency: 'Radio Frequency',
  other: 'Other',
} as const;
